module.exports = __webpack_public_path__ + "static/media/collaborate-feature.3ce5e7a2.svg";